export var EvergreenCommunityListingSignupRequestSource;
(function (EvergreenCommunityListingSignupRequestSource) {
    EvergreenCommunityListingSignupRequestSource["AvailabilityRequestEmail"] = "AvailabilityRequestEmail";
    EvergreenCommunityListingSignupRequestSource["PricingRequestEmail"] = "PricingRequestEmail";
    EvergreenCommunityListingSignupRequestSource["ClientIntakeEmail"] = "ClientIntakeEmail";
    EvergreenCommunityListingSignupRequestSource["OutreachCampaign"] = "OutreachCampaign";
})(EvergreenCommunityListingSignupRequestSource || (EvergreenCommunityListingSignupRequestSource = {}));
export var EvergreenCommunityListingUpdateRequestSource;
(function (EvergreenCommunityListingUpdateRequestSource) {
    EvergreenCommunityListingUpdateRequestSource["AvailabilityRequestEmail"] = "AvailabilityRequestEmail";
})(EvergreenCommunityListingUpdateRequestSource || (EvergreenCommunityListingUpdateRequestSource = {}));
export var CommissionAccrualStatus;
(function (CommissionAccrualStatus) {
    CommissionAccrualStatus["Owed"] = "Owed";
    CommissionAccrualStatus["Paid"] = "Paid";
})(CommissionAccrualStatus || (CommissionAccrualStatus = {}));
export var InvoiceSplitRuleType;
(function (InvoiceSplitRuleType) {
    InvoiceSplitRuleType["TerritorySplit"] = "territorySplit";
    InvoiceSplitRuleType["ReferralSplit"] = "referralSplit";
})(InvoiceSplitRuleType || (InvoiceSplitRuleType = {}));
export var ObligationType;
(function (ObligationType) {
    ObligationType["TerritorySplit"] = "territorySplit";
    ObligationType["ReferralSplit"] = "referralSplit";
    ObligationType["CorporateLeadFee"] = "corporateLeadFee";
    ObligationType["Credit"] = "credit";
    ObligationType["Royalty"] = "royalty";
    ObligationType["BrandFund"] = "brandFund";
})(ObligationType || (ObligationType = {}));
export var ObligationStatus;
(function (ObligationStatus) {
    ObligationStatus["Due"] = "Due";
    ObligationStatus["Sent"] = "Sent";
    ObligationStatus["Received"] = "Received";
})(ObligationStatus || (ObligationStatus = {}));
export var FranchiseTerritoryStatus;
(function (FranchiseTerritoryStatus) {
    FranchiseTerritoryStatus["Active"] = "Active";
    FranchiseTerritoryStatus["Inactive"] = "Inactive";
})(FranchiseTerritoryStatus || (FranchiseTerritoryStatus = {}));
export var FranchiseFeeStructureMode;
(function (FranchiseFeeStructureMode) {
    FranchiseFeeStructureMode["FlatFee"] = "FlatFee";
    FranchiseFeeStructureMode["PercentPlusMinimum"] = "PercentPlusMinimum";
})(FranchiseFeeStructureMode || (FranchiseFeeStructureMode = {}));
//# sourceMappingURL=types.js.map